import { CardCvcElement, CardExpiryElement, CardNumberElement, useElements, useStripe } from "@stripe/react-stripe-js"
import { ErrorMessage, Field } from "formik"
import { FC, forwardRef, useEffect, useImperativeHandle, useMemo } from "react"
import { showErrorAlert } from "../../../helpers/alert"
import { useSelector } from "react-redux"
import { RootState } from "../../../../setup"

export interface FormCardStripeRef {
  createPaymentMethod: () => Promise<any>
}

interface Props {
  values: any
}

export const FormCardStripe = forwardRef(
  (props: Props, ref: React.Ref<FormCardStripeRef>) => {
    const { values } = props
    const stripe = useStripe()
    const elements = useElements()
    const user = useSelector((state: RootState) => state.auth.user)
    const cardStyles = useMemo(() =>
    ({
        style: {
            base: {
                fontFamily:
                    "'Satoshi', 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
                fontSize: '12px',
                fontWeight: '300',
                color: '#808080',
                lineHeight: '16.8px',
                '::placeholder': {
                    color: '#808080',
                    fontWeight: '300',
                },
                iconColor: '#6B6B6B',
            },
            invalid: { color: '#d32f2f', iconColor: '#d32f2f' },
        },
        hidePostalCode: true,
    }),
        []
    )

    const createPaymentMethod = async () => {
        if (!stripe || !elements) return null

        const cardElement = elements.getElement(CardNumberElement)

        if (!cardElement) {
            showErrorAlert({title:'',message:'Card element not found'})
        }

        const { error, paymentMethod } = await stripe.createPaymentMethod({
            type: 'card',
            card: cardElement,
            billing_details: {
                name: values.card_name,
                email: user?.email,
            },
        })
        if (error) {
            showErrorAlert({title: error?.code?.replaceAll('_', ' '), message: error?.message || ''})
            return null
        }

        return paymentMethod?.id
    }

    useImperativeHandle(ref, () => ({
        createPaymentMethod
    }))

    return (<div className="w-100">
        <div className="tap-add-experience-2-section">
            <span className="team-admin-add-member__section-title">add card information</span>
            <div className='form-field team-admin-add-member__card'>
                <div className="w-100">
                    <label className='field-label'>Name in card</label>
                    <Field name='card_name' className='input' />
                    <ErrorMessage name='card_name' component="div" className="tap-add-experience-text text-danger" />
                </div>
                <div className="w-100 gap-1">
                    <label className='field-label'>Card information</label>
                    <div className='card-input-wrapper w-100 mt-4'>
                        <CardNumberElement options={cardStyles as any} />
                    </div>
                    <div className='card-input-wrapper w-100 mt-6'>
                        <CardExpiryElement options={cardStyles} />
                        <CardCvcElement options={cardStyles} />
                    </div>
                </div>
            </div>
        </div>
    </div>)
})